import { transitionDurations } from "../theme";

export const cardCollectionMotionVariants = {
  hidden: {
    opacity: 0,
    transition: {
      duration: transitionDurations.s,
      ease: "linear" as const,
    },
  },
  visible: {
    opacity: 1,
    transition: {
      duration: transitionDurations.s,
      ease: "linear" as const,
      staggerChildren: 0.1,
      when: "beforeChildren" as const,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: transitionDurations.s,
      ease: "linear" as const,
    },
  },
};

export const cardCollectionChildMotionVariants = {
  hidden: {
    // opacity: 0,
    scale: 0.9,
    transition: {
      duration: transitionDurations.s,
      ease: "linear" as const,
    },
  },
  visible: {
    // opacity: 1,
    scale: 1,
    transition: {
      duration: transitionDurations.s,
      ease: "linear" as const,
    },
  },
  exit: {
    // opacity: 0,
    scale: 0.9,
    transition: {
      duration: transitionDurations.s,
      ease: "linear" as const,
    },
  },
};
